import type { Building } from "building-types/building/buildingTypes";
import type { PropInstanceV1, PropInstance } from "building-types/props/propInstanceTypes";
import type { Room } from "building-types/rooms/roomTypes";
import { polyLine2EdgeLength } from "geom/polyLine2";
import { edgeHostedEntityGetLayerEdgeLength } from "./edgePlacementUtils";

export function getHostEdgeLengthForDeprecatedPropInstance(
  prop: PropInstance,
  room: Room,
  building: Pick<Building, "walls">,
) {
  const {
    level: { id: levelId },
  } = room;
  const { wallIndex } = building.walls[levelId];
  const edgeIndex = room.edgeIds.indexOf(prop.edgeId);
  const wallStrip = wallIndex.wallStripFromRoomEdgeIndex(room, edgeIndex);
  if (!wallStrip) {
    return 0;
  }
  const edge = prop.useWallStripMaxOffset ? wallStrip.baselineMaxOffset(true) : wallStrip.baseline(true);
  return polyLine2EdgeLength(edge, 0);
}

export function getHostEdgeLengthForPropInstance(
  prop: PropInstance,
  room: Room,
  building: Pick<Building, "roomIndex" | "wallMasses" | "walls" | "mirror">,
): number {
  if (isDeprecatedPropInstance(prop)) {
    return getHostEdgeLengthForDeprecatedPropInstance(prop, room, building);
  }
  return edgeHostedEntityGetLayerEdgeLength(prop, room, building);
}

export function isPropInstanceEntity(entity: any): entity is PropInstance {
  return entity.entityType === "PROP_INSTANCE";
}

export function isDeprecatedPropInstance(wallProp: PropInstance): wallProp is PropInstanceV1 {
  return wallProp.type === "WALL";
}
